import NFA from 'shared/helpers/analytics/NFAnalytics';

export const getSizes = (sizeOptions: ProductDetail.ISizeOption[]) => {
  let outOfStockSizes: string[] = [],
    inStockSizes: string[] = [];

  sizeOptions.forEach((item: ProductDetail.ISizeOption) => {
    if (!item.isOutOfStock) {
      inStockSizes.push(item.sizeName);
    } else outOfStockSizes.push(item.sizeName);
  });
  return {
    inStockSizes,
    outOfStockSizes,
  };
};

export const getSizeOptionsTrackingData = (sizeOptions: ProductDetail.ISizeOption[]) => {
  if (sizeOptions.length === 0) return { availableSizes: '', outOfStockSizes: '' };

  const { inStockSizes, outOfStockSizes } = getSizes(sizeOptions);

  return { availableSizes: inStockSizes.join(','), outOfStockSizes: outOfStockSizes.join(',') };
};

export const updateDataLayerOnSizeSelect = (
  availableSizes: string,
  outOfStockSizes: string,
  sizeOption: ProductDetail.ISizeOption
) => {
  NFA.updateDataLayer({
    availableSizes,
    outOfStockSizes,
    variantType: sizeOption?.sizeName,
    variantProductID: sizeOption?.id,
    MRP: sizeOption.price,
    discountedPrice: sizeOption?.discount,
    discountPercent: sizeOption?.discountedPrice,
  });
};
